/* ELDR Saison-Ebene – hängt die Deko eines Saison-Pakets in feste Slots. Gleich für alle Saisons. */
(function () {
  var root = document.querySelector('[data-eldr-season]');
  if (!root) return;

  function slotTemplate(name) {
    return root.querySelector('template[data-eldr-season-slot="' + name + '"]');
  }

  // Startseiten-Hero: an den Anfang der Startseite setzen (der bisherige Hero ist per CSS ausgeblendet)
  var heroTpl = root.querySelector('template[data-eldr-season-hero]');
  var main = document.getElementById('MainContent');
  if (heroTpl && main && !main.querySelector('.eldr-s-hero')) {
    main.insertBefore(heroTpl.content.cloneNode(true), main.firstChild);
  }

  // Slot: Logo-Deko – an jedes Header-Logo hängen (Desktop- und Handy-Kopfleiste)
  var logoTpl = slotTemplate('logo');
  if (logoTpl) {
    document.querySelectorAll('.site-header__logowrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('.eldr-s-slot--logo')) return;
      var slot = document.createElement('div');
      slot.className = 'eldr-s-slot--logo';
      slot.appendChild(logoTpl.content.cloneNode(true));
      wrapper.appendChild(slot);
    });
  }

  // Easter-Egg: Deko anklicken zeigt Sprüche
  var lines = [];
  var linesEl = root.querySelector('[data-eldr-season-lines]');
  if (linesEl) {
    try {
      lines = JSON.parse(linesEl.textContent).map(function (l) { return l.trim(); }).filter(Boolean);
    } catch (e) { lines = []; }
  }

  // Eine gemeinsame Sprechblase am body. Sie erscheint unter der Kopfleiste,
  // mittig unter der Spinne, und bleibt im sichtbaren Bereich.
  var bubble = null;
  if (lines.length) {
    bubble = document.createElement('div');
    bubble.className = 'eldr-s-bubble';
    bubble.setAttribute('aria-live', 'polite');
    document.body.appendChild(bubble);
  }
  var lineIndex = 0;
  var hideTimer;

  function placeBubble(btn) {
    var header = btn.closest('.site-header, .mobile-nav-bar-wrapper, header');
    var br = btn.getBoundingClientRect();
    var top = header ? header.getBoundingClientRect().bottom : br.bottom;
    var w = bubble.offsetWidth || 200;
    var left = br.left + br.width / 2 - w / 2;
    left = Math.max(12, Math.min(window.innerWidth - w - 12, left));
    bubble.style.top = Math.round(Math.max(top, 0) + 8) + 'px';
    bubble.style.left = Math.round(left) + 'px';
  }

  document.querySelectorAll('[data-eldr-season-critter]').forEach(function (btn) {
    var old = btn.parentNode.querySelector('[data-eldr-season-bubble]');
    if (old) old.remove();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.remove('is-wiggling');
      void btn.offsetWidth;
      btn.classList.add('is-wiggling');
      if (!bubble) return;
      bubble.textContent = lines[lineIndex % lines.length];
      lineIndex++;
      placeBubble(btn);
      bubble.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { bubble.classList.remove('is-visible'); }, 2800);
    });
  });
  window.addEventListener('scroll', function () {
    if (bubble && bubble.classList.contains('is-visible')) bubble.classList.remove('is-visible');
  }, { passive: true });

  // Slot: Ecken-Deko – oben rechts in jeder Navigationsleiste (Desktop und Handy)
  var cornerTpl = slotTemplate('corner');
  if (cornerTpl) {
    document.querySelectorAll('.site-header, .mobile-nav-bar-wrapper').forEach(function (header) {
      if (header.querySelector('.eldr-s-slot--corner')) return;
      var corner = document.createElement('div');
      corner.className = 'eldr-s-slot--corner';
      corner.setAttribute('aria-hidden', 'true');
      corner.appendChild(cornerTpl.content.cloneNode(true));
      header.classList.add('eldr-s-has-corner');
      if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
      header.insertBefore(corner, header.firstChild);
    });
  }

  // Slot: Produkt-Badge – Badges mit dem Saison-Text einfärben (auch nachgeladene Karten)
  var badgeText = (root.getAttribute('data-badge-text') || '').trim().toLowerCase();
  function markBadges() {
    if (!badgeText) return;
    document.querySelectorAll('.custom-badge:not(.eldr-s-badge)').forEach(function (badge) {
      if (badge.textContent.trim().toLowerCase() === badgeText) badge.classList.add('eldr-s-badge');
    });
  }
  markBadges();
  if (badgeText && 'MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; markBadges(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
